import {
  NavLink
} from "react-router-dom";
import { withTheme, css } from '@emotion/react'
import styled from '@emotion/styled';

const SubLink = styled(NavLink)`
  color: ${props => props.theme.colors.primary4};
  display: inline-block;
  padding: 8px;
  text-decoration: none;
  transition: all 0.25s ease;
  width: 100%;
  border-radius: 4px;

  &:hover {
    ${props => !props.isMobile && css`background-color: #d2f1fc;`};
  }
`;

const SubLinkText = styled.span`
  color: ${props => props.theme.colors.primary4};
  display: inline-block;
  padding-bottom: 8px;
  text-decoration: none;
`;

const SubDesc = styled.p`
  color: ${props => props.theme.colors.neutral1};
  font-family: ${props => props.theme.fonts.secondary};
  font-size: ${props => props.theme.fontSizes.xs};
  font-weight: normal;
  line-height: ${props => props.theme.lineHeights.sm};
`;

const SubItem = styled.li`
  background: ${props => props.theme.colors.contrast2};
  padding: 12px 0;

  @media (min-width: ${props => props.theme.breakpoints.lg}) {
    padding: 12px;
  }
`;

const StyledList = styled.ul`

  @media (min-width: ${props => props.theme.breakpoints.lg}) {
    border-width: 0 1px 1px;
    border-style: solid;
    border-color: transparent;
    box-shadow: rgba(0, 0, 0, 0.12) 0px 0px 10px 0px;
    font-weight: normal;

    &:after {
      box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.06);
      content: "";
      display: block;
      height: 10px;
      position: absolute;
      top: -10px;
      width: 280px;
    }
  }
`;

function SponsorsMenu() {
  return (
    <StyledList>
      <SubItem>
        <SubLink to="/sponsors/recruitment-retention">
          <SubLinkText>Recruitment & Retention</SubLinkText>
          <SubDesc>We’ve got everything you need to make your trial a success, all under one roof.</SubDesc>
        </SubLink>
      </SubItem>
      <SubItem>
        <SubLink to="/sponsors/study-websites">
          <SubLinkText>Study Websites</SubLinkText>
          <SubDesc>Get your trial noticed and educate potential patients about the importance of participating in your study for accelerated enrollment.</SubDesc>
        </SubLink>
      </SubItem>
      <SubItem>
        <SubLink to="/sponsors/econsent">
          <SubLinkText>eConsent</SubLinkText>
          <SubDesc>Transform complex protocols to simple consent for complete, acknowledged patient understanding.</SubDesc>
        </SubLink>
      </SubItem>
      <SubItem>
        <SubLink to="/sponsors/apps">
          <SubLinkText>Study Companion Apps</SubLinkText>
          <SubDesc>Improve patient adherence through direct engagement.</SubDesc>
        </SubLink>
      </SubItem>
      <SubItem>
        <SubLink to="/sponsors/trial-reporting">
          <SubLinkText>Trial Reporting</SubLinkText>
          <SubDesc>Get a snapshot of your trial across multiple sites, all from the convenience of a single dashboard.</SubDesc>
        </SubLink>
      </SubItem>
    </StyledList>
  )
}

export default withTheme(SponsorsMenu);